import { ReactNode } from "react";
import Overlay from "shared/components/Overlay";
import { useStretchBuilder } from "stores/useStretchBuilder";

export const TrainMapOverlayProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isStretchBuilderMode, closeAndResetStretchBuilder] = useStretchBuilder(
    (state) => [
      state.isStretchBuilderMode(),
      state.closeAndResetStretchBuilder,
    ],
  );

  const handleOverlayClick = () => {
    closeAndResetStretchBuilder();
  };

  return (
    <>
      <Overlay $open={isStretchBuilderMode} onClick={handleOverlayClick} />
      {children}
    </>
  );
};
